export const updateHeaderWidthToSlide = () => {
  const header = document.querySelector('.storeeel-header');
  const activeWrapper = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active .slide-media-wrapper');
  if (header && activeWrapper) {
    if (window.storeeelItems && window.storeeelItems.isMobile) {
      header.style.width = '92vw';
    } else {
      // transform: scale(...) の影響を受けない “生の” レイアウト幅を使用
      header.style.width = `${activeWrapper.offsetWidth}px`;
    }
  }
};
